import React from 'react';

import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';

import dictionary from './Loader.dictionary.json';

import styles from './Loader.module.scss';

export const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Spinner className={styles.spinner} />
      <p className={styles.title}>{t(dictionary.title)}</p>
    </div>
  );
};
